$(document).ready(function(){
      $(".recommendation-slider").slick({
        draggable: true,
        infinite: true,
        autoplay: false,
        arrows: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        prevArrow: '.custom-prev',
        nextArrow: '.custom-next', 
        responsive: [
        {
          breakpoint: 544,
          settings: {
            slidesToShow: 2
          }
        }
      ]
      });
})